import cls from 'classnames';
import { capitalize } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '../FormElements';
import './index.scss';

const Chip = ({
    color = 'light',
    text,
    icon = null,
    onRemove,
    outlined = false,
    className = '',
    component: Component = 'div',
    ...restProps
}) => {
    let classes = {
        's-btn-light': color === 'light',
        's-btn-info': color === 'info',
        's-btn-white': color === 'white',
        's-btn-success': color === 'success',
        's-btn-primary': color === 'primary',
        's-btn-secondary': color === 'secondary',
        's-btn-danger': color === 'danger',
        's-btn-warning': color === 'warning',
    };

    if (outlined) {
        classes = {
            's-btn-light-outlined': color === 'light',
            's-btn-info-outlined': color === 'info',
            's-btn-white-outlined': color === 'white',
            's-btn-success-outlined': color === 'success',
            's-btn-primary-outlined': color === 'primary',
            's-btn-secondary-outlined': color === 'secondary',
            's-btn-danger-outlined': color === 'danger',
            's-btn-warning-outlined': color === 'warning',
        };
    }

    return (
        <Component
            className={cls('chip rounded-pill border styled-button',
                !text && 'icon-chip',
                className,
                classes,
                !icon && !text && 'empty-chip',
            )}
            {...restProps}
        >
            <span className="text-truncate">{text || icon}</span>

            {Boolean(onRemove) && (
                <IconButton
                    className={`color${capitalize(color)} ml-1`}
                    size="sm"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </IconButton>
            )}
        </Component>
    );
};

export default Chip;